'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth, useGetUser } from '@morfi/backend-sdk-v2/client';
import { PortfolioBody } from '@/components/portfolio/portfolio-body';
import { PortfolioContext } from '@/components/portfolio/portfolio-context';
import { PortfolioLoadingSkeleton } from '@/components/portfolio/portfolio-loading-skeleton';
import { useRoutePerf } from '@/hooks/use-route-perf';
import { PORTFOLIO_USER_PROFILE_FIELDS } from '@/lib/sdk/projections';
import { useMultiWalletFeature } from '@/providers/multi-wallet-feature-provider';
interface ConnectedProvider {
  provider: string;
  username?: string;
  displayName?: string;
}
interface OtherPortfolioProps {
  /** The user id from the URL — the user being viewed. */
  targetId: string;
}
export function OtherPortfolio(t0) {
  const $ = _c(41);
  const {
    targetId
  } = t0;
  const {
    isLoading: authLoading
  } = useAuth();
  const {
    enabled: multiWalletEnabled
  } = useMultiWalletFeature();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [...PORTFOLIO_USER_PROFILE_FIELDS];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== targetId) {
    t2 = {
      identifier: targetId,
      fields: t1
    };
    $[1] = targetId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: publicUserForProfile,
    isPending: publicProfilePending
  } = useGetUser(t2);
  const t3 = !authLoading && !publicProfilePending;
  let t4;
  if ($[3] !== t3 || $[4] !== targetId) {
    t4 = {
      name: "profile",
      isReady: t3,
      instanceKey: targetId
    };
    $[3] = t3;
    $[4] = targetId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useRoutePerf(t4);
  if (authLoading || publicProfilePending) {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <PortfolioLoadingSkeleton />;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  const publicRecord = publicUserForProfile as Record<string, unknown> | undefined;
  const targetWalletPubkey = typeof publicRecord?.pubkey === "string" ? publicRecord.pubkey : "";
  let t5;
  if ($[7] !== publicRecord) {
    t5 = Array.isArray(publicRecord?.wallets) ? publicRecord.wallets as {
      publicKey: string;
    }[] : [];
    $[7] = publicRecord;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const targetWallets = t5;
  let t6;
  if ($[9] !== targetWalletPubkey || $[10] !== targetWallets) {
    t6 = targetWallets.length > 0 ? targetWallets.map(_temp) : targetWalletPubkey.length > 0 ? [targetWalletPubkey] : [];
    $[9] = targetWalletPubkey;
    $[10] = targetWallets;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const allTargetWalletPubkeys = t6;
  let t7;
  if ($[12] !== allTargetWalletPubkeys || $[13] !== multiWalletEnabled || $[14] !== targetWalletPubkey) {
    t7 = multiWalletEnabled ? allTargetWalletPubkeys : targetWalletPubkey.length > 0 ? [targetWalletPubkey] : [];
    $[12] = allTargetWalletPubkeys;
    $[13] = multiWalletEnabled;
    $[14] = targetWalletPubkey;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const targetWalletPubkeys = t7;
  const resolvedUserId = typeof publicRecord?.userId === "string" ? publicRecord.userId : targetId;
  const financialQueryId = multiWalletEnabled ? resolvedUserId : targetWalletPubkey;
  let t8;
  if ($[16] !== publicRecord) {
    t8 = Array.isArray(publicRecord?.connectedProviders) ? publicRecord.connectedProviders as ConnectedProvider[] : [];
    $[16] = publicRecord;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const connectedProviders = t8;
  const t9 = targetWalletPubkey.length > 0 ? targetWalletPubkey : null;
  let t10;
  if ($[18] !== financialQueryId || $[19] !== multiWalletEnabled || $[20] !== resolvedUserId || $[21] !== t9 || $[22] !== targetWalletPubkey || $[23] !== targetWalletPubkeys) {
    t10 = {
      viewerMode: "other",
      userId: resolvedUserId,
      financialQueryId,
      primaryWalletPubkey: t9,
      walletPubkey: targetWalletPubkey,
      walletPubkeys: targetWalletPubkeys,
      multiWalletEnabled
    };
    $[18] = financialQueryId;
    $[19] = multiWalletEnabled;
    $[20] = resolvedUserId;
    $[21] = t9;
    $[22] = targetWalletPubkey;
    $[23] = targetWalletPubkeys;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = typeof publicRecord?.userId === "string" ? publicRecord.userId : null;
  const t12 = publicUserForProfile?.createdAt ?? null;
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [];
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = publicRecord?.displayName as string | null ?? null;
  const t15 = publicRecord?.handle as string | null ?? null;
  const t16 = publicUserForProfile?.bio ?? null;
  const t17 = publicRecord?.avatarUrl as string | null ?? null;
  const t18 = publicRecord?.avatarNsfw as boolean | null | undefined ?? null;
  const t19 = (publicRecord?.avatarPreferences as {
    rasterise?: boolean;
  } | null | undefined)?.rasterise ?? null;
  const t20 = publicRecord?.heroUrl as string | null | undefined ?? null;
  const t21 = publicRecord?.heroNsfw as boolean | null | undefined ?? null;
  let t22;
  if ($[26] !== connectedProviders || $[27] !== t11 || $[28] !== t12 || $[29] !== t14 || $[30] !== t15 || $[31] !== t16 || $[32] !== t17 || $[33] !== t18 || $[34] !== t19 || $[35] !== t20 || $[36] !== t21) {
    t22 = <PortfolioBody creatorUserId={t11} registeredAt={t12} wallets={t13} primaryWallet={null} displayName={t14} handle={t15} bio={t16} avatarUrl={t17} avatarNsfw={t18} avatarRasterise={t19} heroUrl={t20} coverNsfw={t21} connectedProviders={connectedProviders} />;
    $[26] = connectedProviders;
    $[27] = t11;
    $[28] = t12;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t10 || $[39] !== t22) {
    t23 = <PortfolioContext.Provider value={t10}>{t22}</PortfolioContext.Provider>;
    $[38] = t10;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  return t23;
}
function _temp(w) {
  return w.publicKey;
}